import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const API_URL = process.env.REACT_APP_API_URL
const TOKENS_URL = `${API_URL}/tokens`
const FAUCET_URL = `${API_URL}/faucet`

console.log(`ENV: ${process.env.NODE_ENV}`)
console.log(`API_URL: ${API_URL}`)

interface Props {
    className?: string
}

function App({ className }: Props) {
    const [address, setAddress] = useState('')
    const [token, setToken] = useState<any>('TACT')
    const [optionList, setOptionList] = useState<any>()

    useEffect(() => {
        const fetchOptionList = async () => {
            try {
                const resp = await fetch(TOKENS_URL)
                const data = await resp.json()

                setOptionList(data)
            } catch (error) {
                console.log(error)
            }
        }
        fetchOptionList()
    }, [])

    const handleAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(e.target.value)
    }

    const onChangeToken = (amount: string) => {
        setToken(amount)
    }

    const submitFaucetRequest = async () => {
        const msg = JSON.stringify({
            to_address: address,
            symbol: token,
        })

        const headers = new Headers({
            'Content-Type': 'application/json',
        })
        try {
            const resp = await fetch(FAUCET_URL, {
                method: 'POST',
                headers: headers,
                body: msg,
                mode: 'cors',
            })
            await resp.text()

            if (resp.status !== 200) {
                toast(resp.statusText)
            } else {
                toast('success')
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className={className}>
            <ToastContainer position="top-center" />
            <img src="logo.svg" className="logo" alt="" />

            <div className="content">
                <img src="faucet.svg" alt="" />
                <div className="title">Testnet Faucet</div>

                <div className="form">
                    <input
                        className="textfield"
                        placeholder="Ethereum Compatible Address"
                        type="text"
                        value={address}
                        onChange={handleAddress}
                    />
                    <DropDown
                        className="dropdown"
                        options={optionList}
                        onItemClick={onChangeToken}
                    />

                    <button className="submitBtn" onClick={submitFaucetRequest}>
                        Send
                    </button>
                </div>
            </div>
        </div>
    )
}

export default styled(App)`
    .logo {
        margin-left: 24px;
        width: 200px;
    }

    .content {
        text-align: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        right: 0;
    }

    .title {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 60px;
        line-height: 73px;

        margin: 34px 0;
    }

    .form {
        display: flex;
        justify-content: center;

        .textfield {
            width: 400px;
            height: 40px;
            text-indent: 20px;

            border: 2px solid black;
            border-radius: 10px 0 0 10px;
        }

        .dropdown {
            font-size: 16px;
            line-height: 40px;
            border: 2px solid black;
            border-left: none;
            border-radius: 0 10px 10px 0;
            background-color: #6982de;
            color: white;
            cursor: pointer;
        }
    }

    .submitBtn {
        background: linear-gradient(98.29deg, #2b7fff 10.91%, #12299e 100%);
        box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1);
        border-radius: 300px;

        padding: 8px 32px;
        margin-left: 30px;

        color: white;
        box-shadow: none;
        border: none;
        cursor: pointer;

        font-size: 16px;
    }
`

interface DropDownProps {
    onItemClick: any
    options: string[]
    className?: string
}

const DropDown = ({ onItemClick, options, className }: DropDownProps) => {
    const [isMenuOpen, setMenuOpen] = useState(false)
    const [option, setOption] = useState<string>()

    useEffect(() => {
        if (options) {
            setOption(options[0])
        }
    }, [options])

    return (
        <div
            className={className}
            style={{ position: 'relative', minWidth: '100px' }}
        >
            <div onClick={() => setMenuOpen((prev) => !prev)}>{option}</div>
            {isMenuOpen && (
                <Menu>
                    {options.map((option) => (
                        <MenuItem
                            onClick={() => {
                                onItemClick(option)
                                setOption(option)
                                setMenuOpen((prev) => !prev)
                            }}
                        >
                            {option}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </div>
    )
}

const Menu = styled.div`
    position: absolute;
    top: 55px;
    background-color: #6982de;
    min-width: 100px;
    border-radius: 10px;
    border: 2px solid #222222;
`

const MenuItem = styled.div`
    color: white;
    font-size: 16px;
    cursor: pointer;
`
